import { render } from "./ReviewLoginModalHandler.vue?vue&type=template&id=b05b8c5c"
import script from "./ReviewLoginModalHandler.vue?vue&type=script&lang=js"
export * from "./ReviewLoginModalHandler.vue?vue&type=script&lang=js"

import "./ReviewLoginModalHandler.vue?vue&type=style&index=0&id=b05b8c5c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/review/modals/ReviewLoginModalHandler.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b05b8c5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b05b8c5c', __exports__)) {
    api.reload('b05b8c5c', __exports__)
  }
  
  module.hot.accept("./ReviewLoginModalHandler.vue?vue&type=template&id=b05b8c5c", () => {
    api.rerender('b05b8c5c', render)
  })

}


export default __exports__